import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  loading : boolean = true;
  countdown: string[] = ["00","00","00","00"];

  constructor() { }

  ngOnInit(): void {
    setTimeout(()=>{ this.loading = false }, 1000);
    this.countdownTimer();
    // setInterval(()=>{ this.countdownTimer() }, 1000);

    let maxHeight: number = 0;
    $(".events-slide").each(function(){
      if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    // maxHeight += 270;
    // console.log(maxHeight)

    // $(".events-slide").height(maxHeight);

  }

  countdownTimer(){
    let now: Date = new Date();
    let nextSunday: Date = new Date();

    if(nextSunday.getDay() == 0 && nextSunday.getHours()<10){

    }
    else if(nextSunday.getDay() == 0 && nextSunday.getHours()>10){
      nextSunday.setDate(nextSunday.getDate() + 7);
      nextSunday = new Date(
        nextSunday.getFullYear(),
        nextSunday.getMonth(),
        nextSunday.getDate(),10,0,0);
    }
    else{
      while (nextSunday.getDay() != 0) {
        nextSunday.setDate(nextSunday.getDate() + 1);
      }
      nextSunday = new Date(
        nextSunday.getFullYear(),
        nextSunday.getMonth(),
        nextSunday.getDate(),10,0,0);
    }


    // console.log(now, now.getDay(), nextSunday)
  }

}
